import type { DatasetSummary } from '@/lib/contract';
import { Badge } from '@/ui/badge';

type Availability = DatasetSummary['availability'];

const TONE: Record<'available' | 'reserved' | 'delivered', 'pass' | 'warn' | 'neutral'> = {
  available: 'pass',
  reserved: 'warn',
  delivered: 'neutral'
};

/** Catalog card corner badge: AVAILABLE / RESERVED / DELIVERED. */
export function AvailabilityBadge({ availability }: { availability: Availability }) {
  if (!availability) return null;
  return <Badge tone={TONE[availability]}>{availability}</Badge>;
}
